import { __assign } from "tslib";
import React from 'react';
import classNames from 'classnames';
import { Text } from '@tencent/tea-component/lib/text';
import { useDefaultValue } from '@tencent/tea-component/lib/form/controlled';
export function BuyComparePackageList(props) {
    var _a = useDefaultValue(props, ''), value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, options = _a.options;
    return (React.createElement("div", { className: "buy-compare-package-list" }, options.map(function (option, index) { return (React.createElement(BuyComparePackageListOption, __assign({}, option, { key: index, active: option.packageId === value, onClick: function (event) {
            var _a;
            (_a = option.onClick) === null || _a === void 0 ? void 0 : _a.call(option, option.packageId);
            if (value !== option.packageId) {
                onChange(option.packageId, { event: event });
            }
        } }))); })));
}
function BuyComparePackageListOption(_a) {
    var title = _a.title, desc = _a.desc, tag = _a.tag, price = _a.price, oldPrice = _a.oldPrice, unit = _a.unit, contents = _a.contents, active = _a.active, disabled = _a.disabled, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
    return (React.createElement("div", { className: classNames('buy-compare-package-list-option', { 'buy-compare-package-list-option-disabled': disabled }, { 'buy-compare-package-list-option-active': active }), onClick: function (e) {
            if (!disabled) {
                onClick(e);
            }
        } },
        React.createElement("div", { className: "buy-compare-package-list-option-title" },
            React.createElement("div", { className: "title-info" },
                React.createElement("div", { className: "title" },
                    React.createElement("h4", null, title),
                    tag && React.createElement("span", { className: "tag" }, tag)),
                React.createElement("p", null, desc)),
            React.createElement("div", { className: "price" },
                React.createElement(Text, { theme: "cost" },
                    price,
                    unit),
                oldPrice && (React.createElement(Text, { theme: "cost", className: "old-price" },
                    oldPrice,
                    unit)))),
        React.createElement("ul", { className: "buy-compare-package-list-option-list" }, contents.map(function (item, listIndex) { return (React.createElement("li", { key: listIndex, className: "buy-compare-package-list-option-list__item" },
            React.createElement("span", null, item.label),
            React.createElement("span", null, item.unit))); }))));
}
//# sourceMappingURL=BuyComparePackageList.js.map